/* Bear Playgrounds — Product Gallery Fix
   Upload this file to: Shopify Admin > Themes > Edit code > Assets
   Then add this one line to theme.liquid just before </body>:

   {{ 'gallery-height-fix.js' | asset_url | script_tag }}
*/

(function () {

  // ── 1. DYNAMIC GALLERY HEIGHT ──────────────────────────────────────────────
  // Resizes the gallery container to each slide's natural aspect ratio so
  // thumbnails always sit tight below the image with no extra gap.
  function updateGalleryHeight() {
    var slidesEl = document.querySelector(
      '.product-information__media slideshow-slides'
    );
    var container = document.querySelector(
      '.product-information__media slideshow-container'
    );
    if (!slidesEl || !container) return;

    var activeSlide = Array.from(slidesEl.children).find(function (s) {
      return s.getAttribute('aria-hidden') === 'false';
    });
    if (!activeSlide) return;

    var media = activeSlide.querySelector('.product-media');
    if (!media) return;

    var ratio = parseFloat(
      getComputedStyle(media).getPropertyValue('--ratio').trim()
    );
    if (!ratio || isNaN(ratio)) return;

    container.style.transition = 'height 0.3s ease';
    container.style.height = Math.round(container.offsetWidth / ratio) + 'px';
  }

  // ── 2. KEYBOARD ACCESSIBILITY ─────────────────────────────────────────────
  // Allows Left/Right arrow keys to navigate the gallery when focus is anywhere
  // inside the product media area — works alongside the existing Tab + Enter/Space
  // support on the native arrow buttons.
  function initKeyboardNav() {
    var mediaArea = document.querySelector('.product-information__media');
    if (!mediaArea) return;

    var wrapper = mediaArea.querySelector('.product-media-gallery-badge-wrapper');
    if (!wrapper) return;

    mediaArea.addEventListener('keydown', function (e) {
      // Only act when focus is inside the media area
      if (!mediaArea.contains(document.activeElement)) return;

      if (e.key === 'ArrowLeft') {
        var prevBtn = wrapper.querySelector('.slideshow-control--previous');
        if (prevBtn) {
          e.preventDefault();
          prevBtn.click();
          prevBtn.focus(); // keep focus visible for screen readers
        }
      } else if (e.key === 'ArrowRight') {
        var nextBtn = wrapper.querySelector('.slideshow-control--next');
        if (nextBtn) {
          e.preventDefault();
          nextBtn.click();
          nextBtn.focus();
        }
      }
    });

    // Make the slideshow-slides container focusable so arrow keys work
    // even before the user has tabbed to the arrow buttons
    var slidesEl = mediaArea.querySelector('slideshow-slides');
    if (slidesEl && !slidesEl.hasAttribute('tabindex')) {
      slidesEl.setAttribute('tabindex', '0');
      slidesEl.setAttribute('aria-label', 'Product image gallery. Use left and right arrow keys to navigate.');
      slidesEl.setAttribute('role', 'region');
    }
  }

  // ── 3. THUMBNAIL HOVER ────────────────────────────────────────────────────
  // Subtle scale-up on hover for thumbnail strip.
  function initThumbnailHover() {
    var thumbs = document.querySelectorAll(
      '.product-information__media .slideshow-controls__thumbnail'
    );
    thumbs.forEach(function (thumb) {
      thumb.style.transition = 'transform 0.2s ease-in-out';
      thumb.addEventListener('mouseenter', function () {
        thumb.style.transform = 'scale(1.08)';
      });
      thumb.addEventListener('mouseleave', function () {
        thumb.style.transform = 'scale(1)';
      });
    });
  }

  // ── 4. REMOVE ANY PREVIOUSLY SET BACKGROUND COLOUR ───────────────────────
  function removeSlideBackground() {
    var slides = document.querySelectorAll(
      '.product-information__media slideshow-slide'
    );
    slides.forEach(function (slide) {
      slide.style.backgroundColor = '';
    });
  }

  // ── INIT ──────────────────────────────────────────────────────────────────
  function init() {
    updateGalleryHeight();

    var slidesEl = document.querySelector(
      '.product-information__media slideshow-slides'
    );
    if (slidesEl) {
      new MutationObserver(updateGalleryHeight).observe(slidesEl, {
        attributes: true,
        subtree: true,
        attributeFilter: ['aria-hidden']
      });
    }
    window.addEventListener('resize', updateGalleryHeight);

    initKeyboardNav();
    initThumbnailHover();
    removeSlideBackground();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
